// import { get_sample_types } from "../../../redux/po_backlog/backlog.selector";
import { CustomCollectorDatePicker } from "../components/CustomCollectorDatePicker";
import { fetchSampleType } from "./sampleCollectorServices";

export const convert_dd_mm_yy_to_Date = (date_string) => {
  // console.log(date_string);
  const [dd, mm, yy] = date_string.split("/")?.map((d) => parseInt(d));
  return new Date(yy, mm - 1, dd);
};

// const sample_types = await fetchSampleType();

export const date_time_string_to_date = (date_time_string) => {
  // console.log({ date_time_string, d: new Date(date_time_string) });
  return new Date(date_time_string);
};

export const date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    return value && convert_dd_mm_yy_to_Date(value);
  },
};

export const sampleCollectorGridColumns = {
  // "_id": {
  //   field: "_id",
  //   headerName: "ID",
  //   visible: false,
  //   flex: 1,
  // },
  material: {
    field: "material",
    headerName: "MATERIAL",
    visible: true,
    editable: false,
    width: 150,
  },
  material_description: {
    field: "material_description",
    headerName: "MATERIAL DESCRIPTION",
    visible: true,
    editable: false,
    width: 300,
  },
  batch_no: {
    field: "batch_no",
    headerName: "BATCH",
    visible: true,
    editable: false,
    width: 100,
  },
  order: {
    field: "order",
    headerName: "ORDER",
    isEditable: false,
    width: 100,
  },

  unit: {
    field: "unit",
    headerName: "UNIT",
    isEditable: false,
    width: 100,
  },
  "stor._loc.": {
    field: "stor._loc.",
    headerName: "STORAGE LOCATION",
    width: 150,
    isEditable: false,
  },
  expected_delivery_date_by_production: {
    field: "expected_delivery_date_by_production",
    headerName: "EXPECTED DELIVERY DATE BY PRODUCTION",
    visible: true,
    editable: false,
    width: 300,
    type: "dateTime",
    valueGetter: ({ value }) => {
      if (typeof value === "object") return value;
      return value && new Date(value);
    },
    // renderCell: render_po_date_picker
  },
  sample_collector: {
    field: "sample_collector",
    headerName: "SAMPLE COLLECTOR",
    isEditable: false,
    width: 200,
  },
  spec_id: {
    field: "spec_id",
    headerName: "SPEC ID",
    visible: true,
    editable: true,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    //   { label: "FS015148", value: "FS015148" },
    //   { label: "FS007940", value: "FS007940" },
    //   { label: "FS007772", value: "FS007772" },
    //   { label: "FS011879", value: "FS011879" },
    //   { label: "FS012696", value: "FS012696" },
    //   { label: "FS017600", value: "FS017600" },
    // ],
  },
  stp_id: {
    field: "stp_id",
    headerName: "STP ID",
    visible: true,
    editable: true,
    width: 150,
    // type: "singleSelect",
    // valueOptions: [
    //   { label: "FT007296", value: "FT007296" },
    //   { label: "FT003572", value: "FT003572" },
    //   { label: "FT003702", value: "FT003702" },
    //   { label: "FT005640", value: "FT005640" },
    //   { label: "FT010562", value: "FT010562" },
    //   { label: "FT006061", value: "FT006061" },
    //   { label: "FT008844", value: "FT008844" },
    //   { label: "FT010888", value: "FT010888" },
    // ]
  },
  market: {
    field: "market",
    headerName: "MARKET",
    visible: true,
    editable: true,
    width: 150,
  },
  sample_type: {
    field: "sample_type",
    headerName: "MATERIAL TYPE",
    visible: true,
    editable: true,
    width: 150,
    type: "singleSelect",
    valueOptions: localStorage.getItem("token") ? fetchSampleType() : [],
  },
  expected_delivery_date_by_ip_qa: {
    field: "expected_delivery_date_by_ip_qa",
    headerName: "EXPECTED DELIVERY DATE BY IP QA",
    visible: true,
    editable: false,
    width: 250,
    // type: "dateTime",
    // valueGetter: ({ value }) => {
    //   if (typeof value === "object") return value;
    //   return value && new Date(value);
    // },
    renderCell: CustomCollectorDatePicker
  },
  // "receiving_date_by_qc": {
  //   field: "receiving_date_by_qc",
  //   headerName: "RECEIVING DATE BY QC",
  //   visible: true,
  //   editable: false,
  //   width: 220,
  //   type: "dateTime",
  //   // ...date_column_properties,
  //   valueGetter: ({ value }) => {
  //     if (typeof value === "object") return value;
  //     return value && date_time_string_to_date(value);
  //   },
  //   renderCell: render_po_date_picker
  // },
};
